import moment, { Moment } from 'moment-timezone'
import { AppraisalSeasonDto } from '../../../types'
import { TimeZoneAndLocale } from '../../../types.custom'

export interface InviteModalContentUtilsInput {
  timeZoneAndLocale: TimeZoneAndLocale
  appraisalSeason?: AppraisalSeasonDto
}

export class InviteModalContentUtils {
  private timeZoneAndLocale: TimeZoneAndLocale
  private appraisalSeason?: AppraisalSeasonDto

  public constructor(input: InviteModalContentUtilsInput) {
    this.timeZoneAndLocale = input.timeZoneAndLocale
    this.appraisalSeason = input.appraisalSeason
    this.isMeetingDateNotAvailable = this.isMeetingDateNotAvailable.bind(this)
    this.isMeetingDateNotAllowed = this.isMeetingDateNotAllowed.bind(this)
  }

  public isMeetingDateAvailableWithRespectTo(current: Moment | null, date: Moment): boolean {
    return !this.isMeetingDateNotAvailableWithRespectTo(current, date)
  }

  private isMeetingDateNotAvailableWithRespectTo(current: Moment | null, date: Moment): boolean {
    if (current) {
      if (current.isBefore(date, 'day')) {
        // You cannot schedule a meeting in the past.
        return true
      }

      const { locale, timezone } = this.timeZoneAndLocale
      const appraisalSeasonToDate = this.appraisalSeason ? moment(this.appraisalSeason.toDate).locale(locale).tz(timezone) : undefined
      const nextThreeMonthsDate = date.add(3, 'months')
      const upperBound =
        appraisalSeasonToDate && appraisalSeasonToDate.isBefore(nextThreeMonthsDate)
          ? moment(appraisalSeasonToDate).subtract(1, 'seconds').tz(timezone)
          : nextThreeMonthsDate
      if (current.isAfter(upperBound)) {
        // you cannot schedule a meeting beyond three months of the current day and beyond AS toDate.
        return true
      }
    }
    return false
  }

  public isMeetingDateNotAllowed(dateString: string): boolean {
    const { locale, timezone } = this.timeZoneAndLocale
    const date = moment(dateString).locale(locale).tz(timezone)
    const now: Moment = moment().locale(locale).tz(timezone)

    if (date.isBefore(now)) {
      // You cannot schedule a meeting in the past.
      return true
    }

    const appraisalSeasonToDate = this.appraisalSeason ? moment(this.appraisalSeason.toDate).locale(locale).tz(timezone) : undefined
    const nextThreeMonthsDate = now.add(3, 'months')
    const upperBound =
      appraisalSeasonToDate && appraisalSeasonToDate.isBefore(nextThreeMonthsDate)
        ? moment(appraisalSeasonToDate).subtract(1, 'seconds').tz(timezone)
        : nextThreeMonthsDate

    if (date.isAfter(upperBound)) {
      // you cannot schedule a meeting beyond three months of the current day and beyond AS toDate.
      return true
    }

    return false
  }

  public isMeetingDateNotAvailable(current: Moment | null): boolean {
    const { locale, timezone } = this.timeZoneAndLocale
    const now: Moment = moment().locale(locale).tz(timezone)
    return this.isMeetingDateNotAvailableWithRespectTo(current, now)
  }

  public isMeetingDateInAppraisalSeasonBoundaries(
    meetingDate: Moment,
    appraisalSeason: AppraisalSeasonDto,
  ): boolean {
    const appraisalSeasonMomentFromDate: Moment = moment(appraisalSeason.fromDate).utc()
    const appraisalSeasonMomentToDate: Moment = appraisalSeason.toDate
      ? moment(appraisalSeason.toDate).utc().subtract(1, 'seconds')
      : moment(appraisalSeason.fromDate).utc().add(1, 'years').subtract(1, 'seconds')
    const momentValue: Moment = meetingDate.utc()
    if (momentValue.isBefore(appraisalSeasonMomentFromDate) || momentValue.isAfter(appraisalSeasonMomentToDate)) {
      return false
    }
    return true
  }
}
